import { render, staticRenderFns } from "./TheScroll.vue?vue&type=template&id=6d1082db&scoped=true&"
import script from "./TheScroll.vue?vue&type=script&lang=js&"
export * from "./TheScroll.vue?vue&type=script&lang=js&"
import style0 from "./TheScroll.vue?vue&type=style&index=0&id=6d1082db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1082db",
  null
  
)

export default component.exports